const externalMatchRegex = /^[a-zA-Z]+:/g;

export const isLinkExternal = (href?: string): boolean => {
    if (!href) {
        return false;
    }

    return Boolean(href.match(externalMatchRegex)) || href.startsWith('/api');
};
